import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({ config: {
    connectionString: process.env.REACT_APP_INSIGHT_UI_ConnectionString
    
  } });

appInsights.loadAppInsights();
appInsights.trackPageView();
var telemetryInitializer = (item) => {
    item.tags["OsfHealthCare"] = "FileTransferAdmin app";
  };
appInsights.addTelemetryInitializer(telemetryInitializer);


export { reactPlugin, appInsights };


